<template>
  <div class="number-dictionary" style="height:100%;background:#fff;border-radius:4px;padding:24px">
    <div>
      <span style="color:rgba(18, 18, 18, 1);font-size:16px;font-weight:bold;">号码字典</span>
      <a-button @click="createDictionaries" style="float:right" type="primary">创建</a-button>
    </div>
    <div style="margin-top:20px;">
      <a-table
        :data-source="tableData"
        :pagination='false'
        rowKey="id"
        :scroll="{ y: 'calc(100vh - 390px)' }"
      >
        <a-table-column key="key" title="" data-index="key">
          <template slot-scope="text, record, index">
            <div>
              <span>{{index+1}}</span>
            </div>
          </template>
        </a-table-column>
        <a-table-column key="name" title="字典名称" data-index="name" />
        <a-table-column key="createTime" title="创建时间" data-index="createTime" />
        <a-table-column key="updateTime" title="修改时间" data-index="updateTime" />
        <a-table-column key="num" title="号码数量" data-index="num" />
        <a-table-column key="id" title="操作" data-index="id">
          <template slot-scope="text, record">
            <div>
              <span class="operate-item" @click="editDictionaries(record.id,record.name)" style="cursor:pointer">编辑</span>
              <span class="operate-item" @click="deleteDictionaries(record.id)" style="margin-left:6px;cursor:pointer">删除</span>
            </div>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="newDictionariesBool" title="新增字典" footer='' width='480px'>
      <div class="edit-modal modal-public">
        <a-divider class="divider1" type="horizontal" />
        <div class="changed-name">输入字典名称：</div>
        <a-input v-model="newPhone" placeholder="请输入号码" />
        <a-divider class="divider2" type="horizontal" />
        <div class="btn-group">
          <a-button type="primary" ghost @click="cancelChangeName">取消</a-button>
          <a-button type="primary" @click="sureChangeName">确定</a-button>
        </div>
      </div>
    </a-modal>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="editDictionariesBool" title="编辑字典" footer='' width='480px'>
      <div class="edit-modal modal-public">
        <a-divider class="divider1" type="horizontal" />
        <div class="changed-name">编辑字典名称：</div>
        <a-input v-model="oldPhone" placeholder="请输入号码" />
        <a-divider class="divider2" type="horizontal" />
        <div class="btn-group">
          <a-button type="primary" ghost @click="cancelEditName">取消</a-button>
          <a-button type="primary" @click="sureEditName">确定</a-button>
        </div>
      </div>
    </a-modal>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="deleteDictionariesBool" footer='' width='480px'>
      <div class="delete-modal modal-public">
          <div class="sure-off-bind">
              <a-icon type="warning" />
              <span>您确定要删除这项字典吗？</span>
          </div>
          <div class="tip">删除后，相应字典数据内容也会被删除</div>
          <a-divider class="divider2" type="horizontal" />
          <div class="btn-group">
              <a-button type="primary" ghost @click="cancelDelete">取消</a-button>
              <a-button type="primary" @click="sureDelete">确定</a-button>
          </div>
      </div>
    </a-modal>
  </div>
</template>

<script> 
export default {
  name: 'NumberDictionary',
  data() {
    return {
      tableData: [],
      newPhone: '',
      newDictionariesBool: false,
      editDictionariesBool: false,
      deleteDictionariesBool: false,
      currentId: '',
      oldPhone: ''
    }
  },
  methods: {
    createDictionaries() {
      this.newDictionariesBool = true
    },
    cancelChangeName() {
      this.newDictionariesBool = false
    },
    sureChangeName() {
      this.newDictionariesBool = false
      this.axios.post('/api/dict', {
        id: '',
        name: this.newPhone,
      })
      .then(response=> {
        if(response.data.code == 0){
          this.$message.success('新增字典成功')
          this.queryBasicData()
        }else{
          this.$message.error(response.data.userTip);
          // if(response.data.code == 'A0200'){
          //   this.$router.push("/Login")
          // }
        }
      })
      .catch(error=> {
        console.log(error);
      });
    },
    editDictionaries(id, name) {
      this.editDictionariesBool = true
      this.currentId = id
      this.oldPhone = name
    },
    cancelEditName() {
      this.editDictionariesBool = false
      this.currentId = ''
      this.oldPhone = ''
    },
    sureEditName() {
      this.editDictionariesBool = false
      this.axios.post('/api/dict', {
        id: this.currentId,
        name: this.oldPhone,
      })
      .then(response=> {
        if(response.data.code == 0){
          this.$message.success('修改字典成功')
          this.queryBasicData()
        }else{
          this.$message.error(response.data.userTip);
          // if(response.data.code == 'A0200'){
          //   this.$router.push("/Login")
          // }
        }
      })
      .catch(error=> {
        console.log(error);
      });
    },
    deleteDictionaries(id) {
      this.deleteDictionariesBool = true
      this.currentId = id
      
    },
    cancelDelete() {
      this.deleteDictionariesBool = false
      this.currentId = ''
    },
    sureDelete() {
      this.deleteDictionariesBool = false
      this.axios.delete('api/dict/'+this.currentId)
      .then(response=> {
        if(response.data.code == 0){
          this.$message.success('删除成功')
          this.queryBasicData()
        }else{
          this.$message.error(response.data.userTip);
          // if(response.data.code == 'A0200'){
          //   this.$router.push("/Login")
          // }
        }
      })
      .catch(error=> {
        console.log(error);
      });
    },
    queryBasicData() {
      this.axios(
        {
          method:'get',
          url:'/api/dict/list', 
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.tableData = response.data.data
        }else{
          this.$message.error(response.data.userTip);
          // if(response.data.code == 'A0200'){
          //     this.$router.push("/Login")
          // }
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
  },
  mounted: function() {
    this.sessionData('set','contentNavItem','NumberDictionary');
    this.queryBasicData()
  }
}
</script>

<style lang="less">
  .modal-public{
    .divider1{
        margin: 0px 0 24px 0;
    }
    .divider2{
        margin: 24px 0 12px;
    }
    .btn-group{
      float: right;
      button{
          // width: 64px;
          height: 32px;
          font-size: 14px;
      }
      button:nth-child(1){
          margin-right: 16px;
      }
    }
    .btn-group2{
      float: right;
      button{
          // width: 64px;
          height: 32px;
          font-size: 14px;
      }
      button:nth-child(1){
          background: #fff;
          color: rgba(121, 136, 155, 0.7);
          border: 1px solid rgba(121, 136, 155, 0.5);
          margin-right: 16px;
      }
      button:nth-child(1):hover{
          background: rgba(121, 136, 155, 0.08);
      }
    }
  }
  .edit-modal{
    padding-bottom: 44px;
    .changed-name{
      color: rgba(153, 153, 153, 1);
      font-size: 14px;
    }
    input{
      margin-top: 8px;
    }
  }
  .delete-modal{
    padding-top: 24px;
    padding-bottom: 44px;
    .sure-off-bind{
        i{
            color: rgba(255, 170, 0, 1);
            font-size: 24px;
        }
        span{
            color: rgba(18, 18, 18, 1);
            font-size: 20px;
            margin-left: 24px;
        }
    }
    .tip{
        color: rgba(80, 80, 80, 1);
        padding-left: 50px;
        margin: 24px 0;
    }
  }
  .number-dictionary{
    .operate-item:hover{
      color: #42DFE4;
    }
  }
</style>
